import { render } from "./Workload.vue?vue&type=template&id=75d0674e"
import script from "./Workload.vue?vue&type=script&lang=js"
export * from "./Workload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__